import * as React from "react"

interface ApproximatelyCostProps {
  totalPrice?: number
}
export const ApproximatelyCost = ({ totalPrice }: ApproximatelyCostProps) => {
  return (
    <div className="container mx-auto">
      <div className="flex items-center justify-between mt-4 py-10 px-4 rounded-xl"></div>
      <div className="header-bg fixed z-40 shadow-xl lg:left-20 top-16 lg:right-20 left-5 right-5 mt-6 lg:gap-4 gap-1 rounded-xl">
        <div className="bg-approximately  flex flex-col lg:flex-row items-center justify-between lg:py-6 py-3 px-4 lg:gap-4 gap-1 rounded-xl">
          <h1 className="lg:text-2xl text-sm whitespace-nowrap text-black font-semibold">
            Personalize your
            <span className="text-gradient-secondary"> buying</span>
            <span className="text-gradient-secondary"> experience</span>
          </h1>
          <p className="text-black flex items-center gap-1 pr-4 lg:text-lg text-sm">
            Approximately Cost:
            <span className="font-extrabold lg:text-xl text-lg text-purple">
              {" "}
              ${totalPrice}
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}
